export default "__VITE_PUBLIC_ASSET__289763d0__"